import { Button, type Props } from '../button/button.component';
import { mergeStyle } from './fill-button.module.css';

export type { Props };

export function FillButton(props: Props) {
  const style = mergeStyle(props.style);
  const newProps = { ...props, style };
  return <Button {...newProps}/>;
}
